// Type definitions for NuruSubs Platform

export type JobStatus = 
  | 'uploaded' 
  | 'audio_extracted' 
  | 'transcribing' 
  | 'translating' 
  | 'generating_output'
  | 'completed' 
  | 'failed'
  | 'queued';

export type MediaType = 'audio' | 'video';

export interface Job {
  jobId: string;
  userId: string;
  status: JobStatus;
  mediaType: MediaType;
  fileName: string;
  fileSize: number;
  duration: number;
  uploadTimestamp: number;
  completionTimestamp?: number;
  errorMessage?: string;
  
  mediaS3Key: string;
  audioS3Key?: string;
  transcriptS3Keys?: {
    sw: string;
    en: string;
    fr: string;
  };
  outputS3Keys?: string[];
  
  transcribeJobName?: string;
  transcribeDuration?: number;
  translateCharCount?: number;
  
  audioExtractedAt?: number;
  transcribedAt?: number;
  translatedAt?: number;
  completedAt?: number;
  
  queuePosition?: number;
}

export interface User {
  userId: string;
  email: string;
  registrationDate: number;
  activeJobCount: number;
  queuedJobs: string[];
  totalJobsSubmitted: number;
  lastLoginTimestamp: number;
}

export interface UsageMetrics {
  metricId: string;
  transcribeMinutesUsed: number;
  transcribeMinutesLimit: number;
  translateCharsUsed: number;
  translateCharsLimit: number;
  s3StorageGB: number;
  s3StorageLimit: number;
  lambdaInvocations: number;
  lambdaInvocationsLimit: number;
  lastUpdated: number;
  alertsSent?: {
    transcribe80?: number;
    transcribe90?: number;
    translate80?: number;
    translate90?: number;
    s3_80?: number;
    s3_90?: number;
  };
}

export interface AuthToken {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface UploadRequest {
  userId: string;
  fileName: string;
  fileSize: number;
  contentType: string;
  duration?: number; // Duration in seconds (optional)
}

export interface UploadResponse {
  jobId: string;
  uploadUrl: string;
  expiresIn: number;
}

export interface ApiError {
  message: string;
  code?: string;
  statusCode?: number;
}

export interface DownloadUrlResponse {
  downloadUrl: string;
  expiresIn: number;
}

export const SUPPORTED_AUDIO_FORMATS = ['mp3', 'wav', 'flac', 'm4a'];
export const SUPPORTED_VIDEO_FORMATS = ['mp4', 'avi', 'mov', 'mkv'];
export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
export const MAX_DURATION = 600; // 10 minutes in seconds
